import { render, staticRenderFns } from "./stepWizard.vue?vue&type=template&id=4784f7a6&scoped=true"
import script from "./stepWizard.vue?vue&type=script&lang=js"
export * from "./stepWizard.vue?vue&type=script&lang=js"
import style0 from "./stepWizard.vue?vue&type=style&index=0&id=4784f7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784f7a6",
  null
  
)

export default component.exports